exports.LoginPageView = require('./LoginPageView').default;
exports.ProfilePageView = require('./ProfilePageView').default;
exports.AuthCallbackView = require('./AuthCallbackView').default;
